import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function SectionHeader({
  eyebrow,
  title,
  highlight,
  meta,
  actionText,
  actionHref,
  className = "",
}) {
  return (
    <div className={`flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-12 sm:mb-16 ${className}`}>
      <div>
        {eyebrow && (
          <p className="font-mono text-[11px] tracking-[0.22em] uppercase text-primary mb-3 sm:mb-4">
            {eyebrow}
          </p>
        )}
        <h2 className="text-4xl sm:text-6xl md:text-7xl font-medium tracking-display leading-[1.05]">
          {title}{" "}
          {highlight && <span className="gradient-purple">{highlight}</span>}
        </h2>
      </div>

      <div className="flex items-center gap-4 sm:self-end">
        {meta && (
          <span className="font-mono text-[11px] tracking-[0.2em] uppercase text-muted-foreground">
            {meta}
          </span>
        )}
        {actionHref && actionText && (
          <Link
            to={actionHref}
            className="group inline-flex items-center gap-1.5 font-mono text-[11px] tracking-[0.2em] uppercase text-primary hover:underline underline-offset-4"
          >
            {actionText}
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        )}
      </div>
    </div>
  );
}
